import React from "react";

export default function BooleanCell(props) {
    return <td>{props.dataItem[props.field] ? "Oui" : "Non"}</td>;
}